"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    topbar: {
      backgroundColor: "#000"
    },
    wrapper: {
      display: "flex",
      justifyContent: "flex-end",
      flexWrap: "wrap",
      padding: 4
    },
    link: _defineProperty({
      color: "#fff",
      fontSize: "14px",
      fontWeight: 500,
      marginLeft: 20,
      lineHeight: 1.5
    }, theme.breakpoints.down("sm"), {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5)
    })
  };
});
var TopBar = function TopBar(_ref) {
  var LinkComponent = _ref.LinkComponent,
    links = _ref.links;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.topbar
  }, /*#__PURE__*/_react["default"].createElement(_core.Container, null, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.wrapper
  }, links.map(function (link, i) {
    return link.path && link.path !== "" ? /*#__PURE__*/_react["default"].createElement(LinkComponent, {
      key: i,
      to: link.path,
      className: classes.link
    }, link.name, " ") : /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      key: i,
      className: classes.link
    }, link.name);
  }))));
};
var _default = exports["default"] = TopBar;